import { connect } from 'react-redux'
import { replace, push } from 'react-router-redux'
import at from 'lodash/at'
import compact from 'lodash/compact'

import { fetchPinsForArea } from '../../actions/pins'

import ServicingTabs from '../../components/servicings/servicing-tabs'

const tabNames = [
  'services',
  'history',
  'map'
]

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.servicingId]
  const area = state.areas[servicing.area]
  var pins = compact(at(state.pins, area.pins)).map((pin) => ({ ...pin, area }))

  pins = pins.map(pin => ({ ...pin, latestHistory: state.pinHistories[pin.latestHistory] }))

  const selectedTab = tabNames.indexOf(ownProps.location.query.tab)

  return {
    selectedTab,
    ...servicing,
    area,
    pins
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchPinsForArea(ownProps.areaId))

  return {
    onTabSelect (tabIndex) {
      dispatch(replace({
        pathname: ownProps.location.pathname,
        query: { tab: tabNames[tabIndex] }
      }))
    },

    onPinPlace ({ x, y }) {
      dispatch(push({
        pathname: ownProps.location.pathname + '/pins/create',
        query: { x, y }
      }))
    },

    onPinClick (pinId) {
      dispatch(push({
        pathname: `${ownProps.location.pathname}/pins/${pinId}`
      }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingTabs)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-tabs-container.js